import { render, staticRenderFns } from "./GotItEvent.vue?vue&type=template&id=0dca2684&scoped=true"
import script from "./GotItEvent.vue?vue&type=script&lang=js"
export * from "./GotItEvent.vue?vue&type=script&lang=js"
import style0 from "./GotItEvent.vue?vue&type=style&index=0&id=0dca2684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dca2684",
  null
  
)

export default component.exports